import { useLanguage, t } from "../../../i18n";
import React, { useEffect, useState } from "react";
import { Card, Badge, Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { HiHeart, HiOutlineHeart, HiHome, HiSparkles, HiClock } from "react-icons/hi2";
import { toast } from "react-toastify";
import ROUTES from "../../../config/routes";
import toggleRoomShortlist from "../../../features/shortlist/services/toggleRoomShortlist";
import { useAuth } from "../../../features/auth/context/AuthContext";
import "./ListingCard.css";
export default function ListingCard({
  listing,
  onShortlistChange
}) {
  useLanguage();
  const navigate = useNavigate();
  const {
    isAuthenticated
  } = useAuth();
  const [isShortlistSubmitting, setIsShortlistSubmitting] = useState(false);
  const [isShortlisted, setIsShortlisted] = useState(() => Boolean(listing?.isShortlisted || listing?.is_favourite || listing?.raw?.is_favourite));
  useEffect(() => {
    setIsShortlisted(Boolean(listing?.isShortlisted || listing?.is_favourite || listing?.raw?.is_favourite));
  }, [listing?.isShortlisted, listing?.is_favourite, listing?.raw?.is_favourite]);
  const isOwnListing = Boolean(listing?.isOwner);
  const communityList = Array.isArray(listing?.nationality) ? listing.nationality : listing?.nationality ? [listing.nationality] : [];
  const visibleCommunities = communityList.slice(0, 2);
  const extraCount = communityList.length - visibleCommunities.length;
  const furnishedLabel = listing?.furnished === "Yes" ? "Furnished" : listing?.furnished === "No" ? "Unfurnished" : "";
  const postedAgo = listing?.posted_ago || listing?.postedAgo || listing?.raw?.posted_ago || listing?.raw?.postedAgo || "";
  const handleToggleShortlist = async event => {
    event.preventDefault();
    event.stopPropagation();
    if (!isAuthenticated) {
      navigate(ROUTES.LOGIN);
      return;
    }
    if (isOwnListing) {
      return;
    }
    if (!listing?.id || isShortlistSubmitting) return;
    try {
      setIsShortlistSubmitting(true);
      const response = await toggleRoomShortlist(listing.id);
      const nextIsShortlisted = Boolean(response?.is_favourite);
      setIsShortlisted(nextIsShortlisted);
      if (nextIsShortlisted) {
        toast.success(t("Room has been shortlisted"));
      } else {
        toast.success(t("Removed from Shortlist"));
      }
      if (onShortlistChange) {
        onShortlistChange(nextIsShortlisted, {
          ...listing,
          isShortlisted: nextIsShortlisted,
          is_favourite: nextIsShortlisted,
          raw: {
            ...(listing?.raw || {}),
            is_favourite: nextIsShortlisted
          }
        });
      }
    } catch (error) {
      toast.error(t(error?.response?.data?.message || error?.message || "Failed to update shortlist."));
    } finally {
      setIsShortlistSubmitting(false);
    }
  };
  return <Card className="bb-listing-card h-100">
    <div className="bb-listing-card__image-wrap">
      {listing?.image ? <img src={listing.image} alt={listing?.title || "Room listing"} className="bb-listing-card__image" /> : <div className="bb-listing-card__image-placeholder">{t("No Image Available")}

      </div>}

      {isOwnListing ? <div className="bb-listing-card__owner-badge">{t("Listed by You")}</div> : <button type="button" className={`bb-listing-card__shortlist-btn ${isShortlisted ? "active" : ""}`} onClick={handleToggleShortlist} aria-label={t(isShortlisted ? "Remove from shortlist" : "Add to shortlist")} disabled={isShortlistSubmitting}>

        {isShortlistSubmitting ? <Spinner animation="border" size="sm" /> : isShortlisted ? <HiHeart /> : <HiOutlineHeart />}
      </button>}
    </div>

    <Card.Body className="d-flex flex-column">
      <div className="bb-listing-card__badges">
        {listing?.type ? <Badge className="bb-listing-pill bb-listing-pill--room-type">
          {t(listing.type)}
        </Badge> : null}

        {listing?.gender ? <Badge className="bb-listing-pill bb-listing-pill--gender" text="dark">

          {t(listing.gender)}
        </Badge> : null}
      </div>

      <div className="bb-listing-card__title">{listing?.title}</div>

      <p className="bb-listing-card__location">
        {t(listing?.district)}, {t(listing?.city)}
      </p>

      {postedAgo ? <div className="bb-listing-card__posted-wrap">
        <span className="bb-listing-card__posted-pill">
          <HiClock />
          <span>{t("Posted ")}{t(postedAgo)}</span>
        </span>
      </div> : null}

      {listing?.houseType || furnishedLabel ? <div className="bb-listing-card__meta-row">
        {listing?.houseType ? <span className="bb-listing-card__meta-item">
          <HiHome />
          <span>{t(listing.houseType)}</span>
        </span> : null}

        {listing?.houseType && furnishedLabel ? <span className="bb-listing-card__meta-divider">•</span> : null}

        {furnishedLabel ? <span className="bb-listing-card__meta-item">
          <HiSparkles />
          <span>{t(furnishedLabel)}</span>
        </span> : null}
      </div> : null}

      {communityList.length ? <div className="bb-listing-card__community-wrap">
        <span className="bb-listing-card__community-label">{t("Preferred Nationalities")}

        </span>

        <div className="bb-listing-card__community-list">
          {visibleCommunities.map(community => <span key={community} className="bb-listing-card__community-pill">

            {t(community)}
          </span>)}

          {extraCount > 0 ? <span className="bb-listing-card__community-pill bb-listing-card__community-pill--muted">
            +{t(extraCount)}{t(" more")}
          </span> : null}
        </div>
      </div> : null}

      <div className="bb-listing-card__price">{t("SAR ")}{t(listing?.price)}{t(" / month")}</div>

      <div className="mt-auto pt-3">
        <Button variant="outline-primary" className="w-100 bb-brand-btn-outline" onClick={() => navigate(`/room-listings/${listing?.id}`)}>{t("View Details")}


        </Button>
      </div>
    </Card.Body>
  </Card>;
}
